import { useEffect } from 'react';
import { useEntityList } from '@backstage/plugin-catalog-react';
import { EntityInfraTypeAnnotationFilter } from './EntityInfraTypeAnnotationFilter';

type InfraTypeCatalogFilterProps = {
  includeTypes?: string[];
  excludeTypes?: string[];
};

/** Applies a client-side include/exclude filter on infrastructure.backstage.io/type. */
export const InfraTypeCatalogFilter = ({
  includeTypes,
  excludeTypes,
}: InfraTypeCatalogFilterProps) => {
  const { updateFilters } = useEntityList();

  useEffect(() => {
    if (includeTypes?.length) {
      updateFilters({
        infraType: new EntityInfraTypeAnnotationFilter(
          'include',
          includeTypes,
        ) as Parameters<typeof updateFilters>[0]['infraType'],
      });
    } else if (excludeTypes?.length) {
      updateFilters({
        infraType: new EntityInfraTypeAnnotationFilter(
          'exclude',
          excludeTypes,
        ) as Parameters<typeof updateFilters>[0]['infraType'],
      });
    } else {
      updateFilters({ infraType: undefined });
    }

    return () => {
      updateFilters({ infraType: undefined });
    };
  }, [includeTypes, excludeTypes, updateFilters]);

  return null;
};
